import { Button, Grid, makeStyles, TextField } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import clsx from "clsx";
import { isAddress } from "ethers/lib/utils";
import { useState } from "react";

const useStyle = makeStyles(() => ({
  rootInput: {
    "& .MuiInputBase-root": {
      height: "2.5rem",
    },
    width: "100%",
  },
  cleanIcon: {
    cursor: "pointer",
  },
  hideCleanIcon: {
    visibility: "hidden",
  },
}));

export default function AddressInput({ setNewAddress }) {
  const cls = useStyle();
  const [accountAddress, setAccountAddress] = useState("");
  const [error, setError] = useState(null);

  const onAccountAddressChange = (event) => {
    const value = event.target.value;
    if (value.length === 0) setError(null);
    else {
      if (!isAddress(value)) {
        setError("Invalid wallet address");
      } else setError(null);
    }
    setAccountAddress(value);
  };

  const onAddAddressClick = () => {
    setNewAddress(accountAddress);
    setAccountAddress("");
  };

  const onClearClick = () => {
    setAccountAddress("");
    setError(null);
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={10} sm={9} xs={12}>
        <TextField
          className={cls.rootInput}
          variant="outlined"
          placeholder="Parse your account address"
          value={accountAddress}
          onChange={onAccountAddressChange}
          error={error !== null}
          helperText={error}
          InputProps={{
            endAdornment: (
              <ClearIcon
                onClick={() => onClearClick()}
                className={clsx({
                  [cls.cleanIcon]: accountAddress.length > 0,
                  [cls.hideCleanIcon]: accountAddress.length === 0,
                })}
              />
            ),
          }}
        />
      </Grid>
      <Grid item md={2} sm={3} xs={12}>
        <Button
          fullWidth
          color="secondary"
          variant="contained"
          disabled={error || accountAddress.length === 0}
          onClick={() => onAddAddressClick()}
        >
          Add Address
        </Button>
      </Grid>
    </Grid>
  );
}
